import React, { useEffect, Suspense, lazy } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getProjects } from './Redux/Actions/ProyectActioins';
import { fetchReviews } from './Redux/Actions/reviewActions';
import { Center, Spinner } from '@chakra-ui/react';

import Layout from './components/Layout';
import IndexPage from './components/indexsado';

// Lazy imports — solo lo necesario, sin rifa
const WebDevelopmentService = lazy(() => import('./components/WebDevelopmentService'));
const PrivacyPolicy = lazy(() => import('./components/PoliticasDePrivacidad'));
const TermsOfService = lazy(() => import('./components/TermsOfService'));
const TikTokLandingPage = lazy(() => import('./components/TikTokLandingPage'));
const CodeShowcasePage = lazy(() => import('./components/CodeShowcasePage'));
const ProjectManager = lazy(() => import('./components/Projectos'));
const AgenciaPage = lazy(() => import('./components/AgenciaPage'));

const PageLoader = () => (
  <Center h="100vh" bg="var(--bg-dark)">
    <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="orange.500" size="xl" />
  </Center>
);

function App() {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(getProjects());
    dispatch(fetchReviews());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Suspense fallback={<PageLoader />}>
      <Routes location={location}>
        {/* Layout con Header y Footer */}
        <Route path="/" element={<Layout />}>
          <Route index element={<IndexPage />} />
          <Route path="code-showcase" element={<CodeShowcasePage />} />
          <Route path="agencia" element={<AgenciaPage />} />
          <Route path="tiktok" element={<TikTokLandingPage />} />
          <Route path="webDev" element={<WebDevelopmentService />} />
          <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="TermsOfService" element={<TermsOfService />} />
        </Route>

        {/* Panel admin — sin layout público */}
        <Route path="/proyects" element={<ProjectManager />} />
      </Routes>
    </Suspense>
  );
}

export default App;
